import React from "react";
import "../less/main.less";
import DOMPurify from 'utils/sanitize';
import { Preloader } from "MWComponents";
import { filterByEnvironment } from "../../../../helpers/utils/environmentFilter";
import { canUseDOM } from "../../../../helpers/canUseDOM";

export default function template() {
  const { page, widget, toggleFaqTab, title, disableScrollTarget, loader, showAll, questionTag = 'h3', titleTag = 'h2' } = this.props,
    QuestionTag = questionTag,
    TitleTag = titleTag,
    items = widget.data ? filterByEnvironment(widget.data) : [];

    const sortedItems = [...items].sort((a, b) => a.order - b.order);
    const rows = (showAll ? sortedItems : sortedItems.slice(0, 3)).map((item, index) => {
      const question = item.title_ua;
      const answer = item.desc_ua;
      return (
        <div className="faq-new-admin__row" key={item.id} id={!disableScrollTarget && index === 0 ? 'frequentlyAskedQuestions' : undefined}>
          <QuestionTag className="faq-new-admin__question" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question) }}></QuestionTag>
          <div className="faq-new-admin__answer" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer) }}></div>
        </div>
      );
    });

    if (loader) {
        return (canUseDOM ? <Preloader /> : null)
    }

  return (
    items.length ?
      (
        <div className="faq-new-admin">
          <div className="container">
            {title && <TitleTag className="faq-new-admin__title">{this.l10n(title)}</TitleTag>}
            <div className="faq-new-admin__body">
              {rows}
            </div>
            {(toggleFaqTab && items.length > 3) && <button className="faq-new-admin__btn" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FAQ_SHORT_NEW_BTN')) }} onClick={toggleFaqTab} id={`${page ? page : ''} faq-button`}></button>}
          </div>
        </div>
      ) : ''

  );
}
